import { render, staticRenderFns } from "./creativity.vue?vue&type=template&id=46f021e0"
import script from "./creativity.vue?vue&type=script&lang=js"
export * from "./creativity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports